// 利用者の正規化応答(Users + related.Groups)を、従来のネスト形(Group 込みの getUserType 形)へ
// 復元する共通ハイドレータ。単一取得(get-user-from-id)と一覧(get-users)は行の形
// (login_id の有無)だけが違うため、行型ジェネリックで両対応する。
// 並び順はサーバーの Users 配列の順序(name 昇順)をそのまま維持する。
import { GroupBase } from "../../schema/generated/Group";
import { usersWithGroupOf } from "./relatedLookup";

export function hydrateUsers<TUser extends { id: string; group_id: string; name: string }>(normalized: { Users: TUser[]; related: { Groups: GroupBase[] } }): (TUser & { Group: GroupBase })[] {
  return [...usersWithGroupOf(normalized.Users, normalized.related.Groups).values()];
}
